var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddElement(_ref, svgRef) {
  var _ref2, _ref3;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 6C15 13.0294 15 16.9706 15 24",
    stroke: "#B3C0BD",
    style: (_ref2 = {
      stroke: "#B3C0BD"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.7020 0.7529 0.7412)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 2.25,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 15L6 15",
    stroke: "#B3C0BD",
    style: (_ref3 = {
      stroke: "#B3C0BD"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.7020 0.7529 0.7412)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 2.25,
    strokeLinecap: "round"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddElement);
export default __webpack_public_path__ + "static/media/AddElement.21a71b75.svg";
export { ForwardRef as ReactComponent };